import pick from 'lodash/pick';
import moment from 'moment';
import { fetchCurrentUser, fetchCurrentUserHasOrdersSuccess } from '../../ducks/user.duck';
import {
  transitions as bookingTransition,
  transitions,
} from '../../transactions/transactionProcessBooking';
import { transitions as dealTransitions } from '../../transactions/transactionProcessDeal';
import { transitions as purchaseTransition } from '../../transactions/transactionProcessPurchase';
import {
  onCreateAuthorize,
  onCreateCharge,
  onGeneratePaymetStatus,
  onRetrieveAuthorize,
} from '../../util/api';
import {
  initiatePrivileged,
  transitionPrivileged,
  onInitiateStcAuthorize,
  onRetrieveStcPayment,
  onConfirmStcPayment,
} from '../../util/api';
// import { initiatePrivileged, transitionPrivileged } from '../../util/api';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import * as log from '../../util/log';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  BUSINESS_PROFILE_LISTING_TYPE,
  DEAL_LISTING_TYPE,
  SERVICE_LISTING_TYPE,
} from '../../util/types';
import { deliveryOptions } from '../CartPage/CartPage.duck';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/CheckoutPage/SET_INITIAL_VALUES';

export const INITIATE_ORDER_REQUEST = 'app/CheckoutPage/INITIATE_ORDER_REQUEST';
export const INITIATE_ORDER_SUCCESS = 'app/CheckoutPage/INITIATE_ORDER_SUCCESS';
export const INITIATE_ORDER_ERROR = 'app/CheckoutPage/INITIATE_ORDER_ERROR';

export const CONFIRM_PAYMENT_REQUEST = 'app/CheckoutPage/CONFIRM_PAYMENT_REQUEST';
export const CONFIRM_PAYMENT_SUCCESS = 'app/CheckoutPage/CONFIRM_PAYMENT_SUCCESS';
export const CONFIRM_PAYMENT_ERROR = 'app/CheckoutPage/CONFIRM_PAYMENT_ERROR';

export const SPECULATE_TRANSACTION_REQUEST = 'app/CheckoutPage/SPECULATE_TRANSACTION_REQUEST';
export const SPECULATE_TRANSACTION_SUCCESS = 'app/CheckoutPage/SPECULATE_TRANSACTION_SUCCESS';
export const SPECULATE_TRANSACTION_ERROR = 'app/CheckoutPage/SPECULATE_TRANSACTION_ERROR';

export const STRIPE_CUSTOMER_REQUEST = 'app/CheckoutPage/STRIPE_CUSTOMER_REQUEST';
export const STRIPE_CUSTOMER_SUCCESS = 'app/CheckoutPage/STRIPE_CUSTOMER_SUCCESS';
export const STRIPE_CUSTOMER_ERROR = 'app/CheckoutPage/STRIPE_CUSTOMER_ERROR';

export const INITIATE_INQUIRY_REQUEST = 'app/CheckoutPage/INITIATE_INQUIRY_REQUEST';
export const INITIATE_INQUIRY_SUCCESS = 'app/CheckoutPage/INITIATE_INQUIRY_SUCCESS';
export const INITIATE_INQUIRY_ERROR = 'app/CheckoutPage/INITIATE_INQUIRY_ERROR';

// Action Types for Charge Request
export const INITIATE_CHARGE_REQUEST = 'app/CheckoutPage/INITIATE_CHARGE_REQUEST';
export const INITIATE_CHARGE_SUCCESS = 'app/CheckoutPage/INITIATE_CHARGE_SUCCESS';
export const INITIATE_CHARGE_ERROR = 'app/CheckoutPage/INITIATE_CHARGE_ERROR';

export const UPDATE_ORDER_DATA_SUCCESS = 'app/CheckoutPage/UPDATE_ORDER_DATA_SUCCESS';

export const PAYMENT_STATUS_REQUEST = 'app/CheckoutPage/PAYMENT_STATUS_REQUEST';
export const PAYMENT_STATUS_SUCCESS = 'app/CheckoutPage/PAYMENT_STATUS_SUCCESS';
export const PAYMENT_STATUS_ERROR = 'app/CheckoutPage/PAYMENT_STATUS_ERROR';

export const FETCH_BUSINESS_LISTING_REQUEST = 'app/CheckoutPage/FETCH_BUSINESS_LISTING_REQUEST';
export const FETCH_BUSINESS_LISTING_SUCCESS = 'app/CheckoutPage/FETCH_BUSINESS_LISTING_SUCCESS';
export const FETCH_BUSINESS_LISTING_ERROR = 'app/CheckoutPage/FETCH_BUSINESS_LISTING_ERROR';

export const SET_COUPON_CODE = 'app/CheckoutPage/SET_COUPON_CODE';
export const COUPON_REJECTED = 'app/CheckoutPage/COUPON_REJECTED';

// ================ Reducer ================ //

const initialState = {
  listing: null,
  orderData: null,
  speculateTransactionInProgress: false,
  speculateTransactionError: null,
  speculatedTransaction: null,
  isClockInSync: false,
  transaction: null,
  initiateOrderError: null,
  confirmPaymentError: null,
  stripeCustomerFetched: false,
  initiateInquiryInProgress: false,
  initiateInquiryError: null,
  cartListings: null,
  cartAuthorId: null,

  initiateChargeInProgress: false,
  initiateChargeError: null,
  chargeData: null, // This will hold the response data if charge is successful
  loading: false,
  data: null,
  error: null,

  businessListingResultId: null,
  fetchBusinessInProgress: false,
  fetchBusinessError: null,

  // Discount code: couponCode is what gets sent with the speculative and the
  // real transactions; it's only kept while the server says it applies.
  // couponResult is the server's last answer ({ status: 'applied' |
  // 'rejected', code, reason?, discountAmount? }).
  couponCode: null,
  couponResult: null,
  couponApplyInProgress: false,
};

// STC: initiate direct payment authorize (wallet by MSISDN)
export const initiateStcAuthorize = stcDetails => async (dispatch, getState) => {
  dispatch(initiateChargeRequest());
  try {
    const { speculatedTransaction } = getState().CheckoutPage;
    const { payinTotal } = speculatedTransaction?.attributes || {};
    const { amount, currency } = payinTotal || {};
    const updatedDetails = { ...stcDetails, amount: amount / 100, currency };

    if (process.env.NODE_ENV !== 'production') {
      console.log('[REDUX][STC][Initiate] Calling API', {
        step: 'REDUX_INITIATE_API_CALL',
        refNum: updatedDetails.RefNum,
        billNumber: updatedDetails.BillNumber,
        mobileNo: updatedDetails.MobileNo ? `${updatedDetails.MobileNo.substring(0, 5)}***` : null,
        amount: updatedDetails.amount,
        currency: updatedDetails.currency,
        requestTxIds: updatedDetails.metadata?.requestTxIds?.split('&&') || [],
      });
    }

    const response = await onInitiateStcAuthorize(updatedDetails);

    if (process.env.NODE_ENV !== 'production') {
      console.log('[REDUX][STC][Initiate] API Response', {
        step: 'REDUX_INITIATE_API_RESPONSE',
        paymentId: response?.id || response?.RefNum,
        status: response?.status,
        hasOtpReference: !!response?.OtpReference,
        hasPmtReference: !!response?.STCPayPmtReference,
        expiryDuration: response?.ExpiryDuration,
        hasError: !!response?.error,
        errorMessage: response?.message,
      });
    }

    // Check if response contains an error
    if (response?.error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('[REDUX][STC][Initiate] API returned error in response', {
          step: 'REDUX_INITIATE_API_ERROR_RESPONSE',
          error: response?.error,
          message: response?.message,
          status: response?.status,
          errorCode: response?.errorCode,
        });
      }
      dispatch(initiateChargeError(response?.message || 'Error initiating STC payment'));
      // Return the error response so frontend can handle it
      return response;
    }

    await dispatch(initiateChargeSuccess(response));
    return response;
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[REDUX][STC][Initiate] API Error', {
        step: 'REDUX_INITIATE_API_ERROR',
        message: error?.message,
        status: error?.status,
      });
    }

    // Extract error message from error object (API assigns response data to error object)
    const errorMessage = error?.message || error?.error?.message || 'Error initiating STC payment';

    dispatch(initiateChargeError(errorMessage));
    // Re-throw with error response data so frontend can display it
    const errorResponse = {
      error: true,
      status: error?.status || 500,
      message: errorMessage,
      errorCode: error?.errorCode || null,
      ...error, // Include all error properties (response data is merged into error object)
    };
    throw errorResponse;
  }
};

// STC: check payment status by paymentId/reference
export const checkStcPaymentStatus = params => async dispatch => {
  const { paymentId } = params || {};
  dispatch(paymentStatusRequest());

  return onRetrieveStcPayment({ paymentId })
    .then(res => {
      dispatch(paymentStatusSuccess(res));
      return res;
    })
    .catch(err => {
      if (process.env.NODE_ENV !== 'production') {
        console.error('[REDUX][STC][Status] Status check error', {
          step: 'REDUX_STATUS_ERROR',
          paymentId: paymentId,
          message: err?.message,
        });
      }
      dispatch(paymentStatusError('Error loading STC payment status'));
      throw err; // Re-throw so caller can handle it
    });
};

// STC: confirm payment with OTP
export const confirmStcPayment = ({
  paymentId,
  OtpValue,
  OtpReference,
  STCPayPmtReference,
}) => async dispatch => {
  dispatch(paymentStatusRequest());

  if (process.env.NODE_ENV !== 'production') {
    console.log('[REDUX][STC][Confirm] Confirming payment', {
      step: 'REDUX_CONFIRM_API_CALL',
      paymentId: paymentId,
      otpLength: OtpValue?.length || 0,
      hasOtpReference: !!OtpReference,
      hasPmtReference: !!STCPayPmtReference,
    });
  }

  return onConfirmStcPayment({ paymentId, OtpValue, OtpReference, STCPayPmtReference })
    .then(res => {
      // Check if response contains an error
      if (res?.error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('[REDUX][STC][Confirm] API returned error in response', {
            step: 'REDUX_CONFIRM_API_ERROR_RESPONSE',
            paymentId: paymentId,
            message: res?.message,
            status: res?.status,
          });
        }
        dispatch(paymentStatusError(res?.message || 'Error confirming STC payment'));
        // Return the error response so frontend can handle it
        return res;
      }

      if (process.env.NODE_ENV !== 'production') {
        console.log('[REDUX][STC][Confirm] Confirm response', {
          step: 'REDUX_CONFIRM_API_RESPONSE',
          paymentId: paymentId,
          status: res?.status,
          paymentStatus: res?.PaymentStatus,
        });
      }
      dispatch(paymentStatusSuccess(res));
      return res;
    })
    .catch(err => {
      if (process.env.NODE_ENV !== 'production') {
        console.error('[REDUX][STC][Confirm] Confirm error', {
          step: 'REDUX_CONFIRM_API_ERROR',
          paymentId: paymentId,
          message: err?.message,
          status: err?.status,
        });
      }

      // Extract error message from error object (API assigns response data to error object)
      // The request function throws error with response data merged into it
      const errorMessage = err?.message || err?.error?.message || 'Error confirming STC payment';

      dispatch(paymentStatusError(errorMessage));
      // Re-throw with error response data so frontend can display it
      const errorResponse = {
        error: true,
        status: err?.status || 500,
        message: errorMessage,
        ...err, // Include all error properties (response data is merged into error object)
      };
      throw errorResponse;
    });
};

export default function checkoutPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SPECULATE_TRANSACTION_REQUEST:
      return {
        ...state,
        speculateTransactionInProgress: true,
        speculateTransactionError: null,
        speculatedTransaction: null,
      };
    case SPECULATE_TRANSACTION_SUCCESS: {
      // Check that the local devices clock is within a minute from the server
      const lastTransitionedAt = payload.transaction?.attributes?.lastTransitionedAt;
      const localTime = new Date();
      const minute = 60000;
      // A code the server didn't apply is dropped so it isn't sent with the
      // real transactions; the result stays so the reason can be shown.
      const couponApplied = payload.coupon?.status === 'applied';
      return {
        ...state,
        speculateTransactionInProgress: false,
        speculatedTransaction: payload.transaction,
        isClockInSync: Math.abs(lastTransitionedAt?.getTime() - localTime.getTime()) < minute,
        couponCode: couponApplied ? state.couponCode : null,
        // No code in play: keep the last answer (e.g. a rejection message)
        // across unrelated re-speculations such as an address change.
        couponResult: state.couponCode ? payload.coupon || null : state.couponResult,
        couponApplyInProgress: false,
      };
    }
    case SPECULATE_TRANSACTION_ERROR:
      if (process.env.NODE_ENV !== 'production')
        console.error('[CheckoutPage] Speculate transaction error:', payload);
      return {
        ...state,
        speculateTransactionInProgress: false,
        speculateTransactionError: payload,
        couponApplyInProgress: false,
      };

    case SET_COUPON_CODE:
      return {
        ...state,
        couponCode: payload,
        couponResult: null,
        couponApplyInProgress: !!payload,
      };
    case COUPON_REJECTED:
      return {
        ...state,
        couponCode: null,
        couponResult: { status: 'rejected', ...payload },
        couponApplyInProgress: false,
      };

    case INITIATE_ORDER_REQUEST:
      return { ...state, initiateOrderError: null };
    case INITIATE_ORDER_SUCCESS:
      return { ...state, transaction: payload };
    case INITIATE_ORDER_ERROR:
      if (process.env.NODE_ENV !== 'production')
        console.error('[CheckoutPage] Initiate order error:', payload);
      return { ...state, initiateOrderError: payload };

    case CONFIRM_PAYMENT_REQUEST:
      return { ...state, confirmPaymentError: null };
    case CONFIRM_PAYMENT_SUCCESS:
      return state;
    case CONFIRM_PAYMENT_ERROR:
      if (process.env.NODE_ENV !== 'production')
        console.error('[CheckoutPage] Confirm payment error:', payload);
      return { ...state, confirmPaymentError: payload };

    case STRIPE_CUSTOMER_REQUEST:
      return { ...state, stripeCustomerFetched: false };
    case STRIPE_CUSTOMER_SUCCESS:
      return { ...state, stripeCustomerFetched: true };
    case STRIPE_CUSTOMER_ERROR:
      if (process.env.NODE_ENV !== 'production')
        console.error('[CheckoutPage] Stripe customer error:', payload);
      return { ...state, stripeCustomerFetchError: payload };

    case INITIATE_INQUIRY_REQUEST:
      return { ...state, initiateInquiryInProgress: true, initiateInquiryError: null };
    case INITIATE_INQUIRY_SUCCESS:
      return { ...state, initiateInquiryInProgress: false };
    case INITIATE_INQUIRY_ERROR:
      return { ...state, initiateInquiryInProgress: false, initiateInquiryError: payload };

    case FETCH_BUSINESS_LISTING_REQUEST:
      return { ...state, fetchBusinessInProgress: true, fetchBusinessError: null };
    case FETCH_BUSINESS_LISTING_SUCCESS:
      return {
        ...state,
        businessListingResultId: payload?.data?.data?.[0]?.id,
      };
    case FETCH_BUSINESS_LISTING_ERROR:
      return { ...state, fetchBusinessInProgress: false, fetchBusinessError: payload };

    case INITIATE_CHARGE_REQUEST:
      return {
        ...state,
        initiateChargeInProgress: true,
        initiateChargeError: null,
      };

    case INITIATE_CHARGE_SUCCESS:
      return {
        ...state,
        initiateChargeInProgress: false,
        chargeData: payload,
      };

    case INITIATE_CHARGE_ERROR:
      return {
        ...state,
        initiateChargeInProgress: false,
        initiateChargeError: payload,
      };

    case UPDATE_ORDER_DATA_SUCCESS:
      return {
        ...state,
        orderData: { ...payload.orderData },
      };
    case PAYMENT_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null, // Reset error when making a new request
      };
    case PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case PAYMENT_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const initiateChargeRequest = () => ({
  type: INITIATE_CHARGE_REQUEST,
});

export const initiateChargeSuccess = chargeData => ({
  type: INITIATE_CHARGE_SUCCESS,
  payload: chargeData,
});

export const initiateChargeError = error => ({
  type: INITIATE_CHARGE_ERROR,
  error,
});

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

const initiateOrderRequest = () => ({ type: INITIATE_ORDER_REQUEST });

const initiateOrderSuccess = order => ({
  type: INITIATE_ORDER_SUCCESS,
  payload: order,
});

const initiateOrderError = e => ({
  type: INITIATE_ORDER_ERROR,
  error: true,
  payload: e,
});

const confirmPaymentRequest = () => ({ type: CONFIRM_PAYMENT_REQUEST });

const confirmPaymentSuccess = orderId => ({
  type: CONFIRM_PAYMENT_SUCCESS,
  payload: orderId,
});

const confirmPaymentError = e => ({
  type: CONFIRM_PAYMENT_ERROR,
  error: true,
  payload: e,
});

export const speculateTransactionRequest = () => ({ type: SPECULATE_TRANSACTION_REQUEST });

export const speculateTransactionSuccess = (transaction, coupon = null) => ({
  type: SPECULATE_TRANSACTION_SUCCESS,
  payload: { transaction, coupon },
});

// Sets (or, with null, removes) the discount code. The caller re-fetches the
// speculated transaction afterwards so the breakdown and total update.
export const setCouponCode = code => ({
  type: SET_COUPON_CODE,
  payload: code ? String(code).trim().toUpperCase() : null,
});

export const couponRejected = ({ code, reason }) => ({
  type: COUPON_REJECTED,
  payload: { code, reason },
});

const discountCodeRejection = e => {
  const error = e?.data?.errors?.[0];
  return error?.code === 'discount-code-rejected' ? error : null;
};

const newCheckoutRef = () =>
  typeof window !== 'undefined' && window.crypto?.randomUUID
    ? window.crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random()
        .toString(36)
        .slice(2)}`;

export const speculateTransactionError = e => ({
  type: SPECULATE_TRANSACTION_ERROR,
  error: true,
  payload: e,
});

export const stripeCustomerRequest = () => ({ type: STRIPE_CUSTOMER_REQUEST });
export const stripeCustomerSuccess = () => ({ type: STRIPE_CUSTOMER_SUCCESS });
export const stripeCustomerError = e => ({
  type: STRIPE_CUSTOMER_ERROR,
  error: true,
  payload: e,
});

export const initiateInquiryRequest = () => ({ type: INITIATE_INQUIRY_REQUEST });
export const initiateInquirySuccess = () => ({ type: INITIATE_INQUIRY_SUCCESS });
export const initiateInquiryError = e => ({
  type: INITIATE_INQUIRY_ERROR,
  error: true,
  payload: e,
});

export const updateOrderData = payload => ({
  type: UPDATE_ORDER_DATA_SUCCESS,
  payload,
});

export const paymentStatusRequest = () => ({
  type: PAYMENT_STATUS_REQUEST,
});

export const paymentStatusSuccess = data => ({
  type: PAYMENT_STATUS_SUCCESS,
  payload: data,
});

export const paymentStatusError = error => ({
  type: PAYMENT_STATUS_ERROR,
  payload: error,
});

export const fetchBusinessListingRequest = () => ({
  type: FETCH_BUSINESS_LISTING_REQUEST,
});

export const fetchBusinessListingSuccess = result => ({
  type: FETCH_BUSINESS_LISTING_SUCCESS,
  payload: result,
});

export const fetchBusinessListingError = error => ({
  type: FETCH_BUSINESS_LISTING_ERROR,
  payload: error,
});

/* ================ Thunks ================ */

export const initiateCharge = chargeDetails => async (dispatch, getState) => {
  dispatch(initiateChargeRequest());
  try {
    const { speculatedTransaction } = getState().CheckoutPage;
    const { payinTotal } = speculatedTransaction?.attributes || {};
    const { amount, currency } = payinTotal || {};
    const updatedChargeDetails = { ...chargeDetails, amount: amount / 100, currency };

    const response = await onCreateCharge(updatedChargeDetails);
    await dispatch(initiateChargeSuccess(response));

    if (response?.transaction?.url) {
      window.location.href = response.transaction.url;
    }

    return response;
  } catch (error) {
    dispatch(initiateChargeError(error.response ? error.response.data : error.message));
  }
};
// END TAP PAYMENT initiateCharge

export const initiateAuthorize = authDetails => async (dispatch, getState) => {
  dispatch(initiateChargeRequest());
  try {
    const { speculatedTransaction } = getState().CheckoutPage;
    const { payinTotal } = speculatedTransaction?.attributes || {};
    const { amount, currency } = payinTotal || {};
    // A split-payment leg (deposit/remainder) already sets its own amount —
    // only fall back to the full transaction total when the caller didn't
    // provide one, so the 50-50 flow's half-amounts survive.
    const updatedAuthDetails = {
      ...authDetails,
      amount: authDetails?.amount != null ? authDetails.amount : amount / 100,
      currency: authDetails?.currency || currency,
    };

    const response = await onCreateAuthorize(updatedAuthDetails);
    await dispatch(initiateChargeSuccess(response));

    if (response?.transaction?.url) {
      window.location.href = response.transaction.url;
    }

    return response;
  } catch (error) {
    dispatch(initiateChargeError(error.response ? error.response.data : error.message));
  }
};
// END TAP PAYMENT initiateAuthorize

export const checkPaymentStatus = (params, search, config) => async (dispatch, getState) => {
  const { paymentId } = params || {};
  dispatch(paymentStatusRequest());

  return onRetrieveAuthorize({ authorize_id: paymentId })
    .then(async res => {
      const { id: statusCustomerId } = res?.customer || {};
      const { id: paymentAgreementId, contract } = res?.payment_agreement || {};
      // `payment_agreement.contract.id` is a different Tap resource than the
      // actual card id (the /v2/card list endpoint's `.id`, which is what
      // /v2/tokens saved_card.card_id expects). Prefer the charge's own
      // `card.id` and only fall back to contract.id if it's absent.
      const cardId = res?.card?.id || contract?.id;
      // statusCustomerId (res.customer.id) is Tap's own top-level,
      // request-scoped customer id -- prefer it. contract.customer_id was
      // originally preferred here on the theory that a customer can have
      // more than one Tap customer record and the contract's id is the
      // "real" owner -- but it's also the field observed echoing back a
      // completely unrelated customer/card when the deposit leg of a split
      // payment forces save_card on an already-saved card (see
      // CheckoutPageWithPayment.js's depositUsesSavedCard fix). Falling back
      // to it only when statusCustomerId is missing keeps the original
      // multi-customer-record case working without trusting contract first.
      const tapCustomerId = statusCustomerId || contract?.customer_id;

      // fetchCurrentUser is async and wasn't being awaited before -- oldCards
      // below could read a stale pre-fetch copy of protectedData.cards out of
      // redux, risking a card that was JUST deleted (or already saved)
      // getting silently re-added/duplicated.
      await dispatch(fetchCurrentUser());
      const currentUser = getState().user?.currentUser || {};
      const oldCards = currentUser?.attributes?.profile?.protectedData?.cards || [];

      const newCard = {
        paymentAgreementId,
        cardId,
      };

      const isExistingCard = !!cardId && oldCards.some(card => card.cardId === cardId);

      const newCardMaybe = !paymentAgreementId || !cardId || isExistingCard ? [] : [newCard];

      const updatedCards = [...oldCards, ...newCardMaybe];

      if (isExistingCard) {
        // Repeat charge on a card we already have saved -- publicData.customerId
        // is already correct (it's literally what was just used to tokenize and
        // charge this exact card). Re-deriving it from this charge's response
        // risks the same customerId drift documented above and made this same
        // saved card untokenizable on a later checkout, since a payment_agreement
        // charge's contract/customer fields aren't guaranteed to echo the same
        // canonical id every time. Nothing new to learn here, so leave it alone.
        dispatch(paymentStatusSuccess(res));
        return res;
      }

      dispatch(
        updateProfile({
          publicData: { customerId: tapCustomerId },
          protectedData: { cards: updatedCards },
        })
      );
      dispatch(paymentStatusSuccess(res));
      return res;
    })
    .catch(err => {
      dispatch(paymentStatusError('Error loading payment status data!', err));
    });
};
// END TAP PAYMENT checkPaymentStatus

/**
 * INITIATE ORDER
 */
export const initiateOrder = ({
  orderParams,
  processAlias,
  transactionId,
  transitionName,
  isPrivilegedTransition,
}) => (dispatch, getState, sdk) => {
  try {
    // If we already have a transaction ID, we should transition, not
    // initiate.
    const isTransition = !!transactionId;

    const { deliveryMethod, quantity, cart, bookingDates, ...otherOrderParams } = orderParams;

    const quantityMaybe = quantity ? { stockReservationQuantity: quantity } : {};

    const bookingParamsMaybe = bookingDates || {};

    // if (bookingDates) {
    //   bookingParamsMaybe = {
    //     ...bookingDates,
    //     bookingEnd: addBuffer(bookingDates?.bookingEnd),
    //     bookingDisplayEnd: bookingDates?.bookingEnd,
    //     bookingDisplayStart: bookingDates?.bookingStart,
    //   };
    // }

    // Parameters only for client app's server
    const orderData = deliveryMethod ? { cart, deliveryMethod } : { cart };

    // Parameters for Marketplace API
    const transitionParams = {
      ...quantityMaybe,
      ...bookingParamsMaybe,
      ...otherOrderParams,
    };

    const bodyParams = isTransition
      ? {
          id: transactionId,
          transition: transitionName,
          params: transitionParams,
        }
      : {
          processAlias,
          transition: transitionName,
          params: transitionParams,
        };
    const queryParams = {
      include: ['booking', 'provider', 'listing'],
      expand: true,
    };

    const handleSucces = response => {
      const entities = denormalisedResponseEntities(response);
      const order = entities[0];
      dispatch(initiateOrderSuccess(order));
      dispatch(fetchCurrentUserHasOrdersSuccess(true));
      return order;
    };

    const handleError = e => {
      if (process.env.NODE_ENV !== 'production') {
        const transactionIdMaybe = transactionId ? { transactionId: transactionId.uuid } : {};
        console.error('[CheckoutPage] Initiate order failed', e?.message, {
          ...transactionIdMaybe,
          listingId: orderParams.listingId?.uuid,
        });
      }
      throw e;
    };
    if (isTransition && isPrivilegedTransition) {
      // transition privileged
      return transitionPrivileged({
        isSpeculative: false,
        orderData,
        bodyParams,
        queryParams,
      })
        .then(handleSucces)
        .catch(handleError);
    } else if (isTransition) {
      // transition non-privileged
      return sdk.transactions
        .transition(bodyParams, queryParams)
        .then(handleSucces)
        .catch(handleError);
    } else if (isPrivilegedTransition) {
      // initiate privileged
      return initiatePrivileged({
        isSpeculative: false,
        orderData,
        bodyParams,
        queryParams,
      })
        .then(handleSucces)
        .catch(handleError);
    } else {
      // initiate non-privileged
      return sdk.transactions
        .initiate(bodyParams, queryParams)
        .then(handleSucces)
        .catch(handleError);
    }
  } catch (error) {}
};

export const confirmPayment = params => (dispatch, getState, sdk) => {
  const { transactionId, transitionName, transitionParams = {} } = params;
  dispatch(confirmPaymentRequest());
  const bodyParams = {
    id: transactionId,
    transition: transitionName,
    params: transitionParams,
  };
  const queryParams = {
    include: ['booking', 'provider', 'listing'],
    expand: true,
  };

  return sdk.transactions
    .transition(bodyParams, queryParams)
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      const order = entities[0];
      dispatch(confirmPaymentSuccess(order?.id));
      return order;
    })
    .catch(e => {
      dispatch(confirmPaymentError(storableError(e)));
      const transactionIdMaybe = transactionId ? { transactionId: transactionId?.uuid } : {};
      log.error(e, 'initiate-order-failed', {
        ...transactionIdMaybe,
      });
      throw e;
    });
};

/**
 * creating child transactions for both service/product
 */
const createChildTransactions = async (orderParams, sdk, isBookingProcess, isDealProcess) => {
  //remove parent listing from cart
  const { attributes, id, listing } = orderParams;
  const parentTransactionId = id.uuid;
  const { cart } = attributes?.protectedData;
  cart?.deliveryMethod ? delete cart?.deliveryMethod : null;
  if (isBookingProcess || isDealProcess) {
    for (const [key, value] of Object.entries(cart)) {
      if (value?.staffId === listing?.id?.uuid) {
        delete cart[key];
        break;
      }
    }
  } else {
    delete cart[listing?.id?.uuid];
  }
  const queryParams = {
    include: ['booking', 'provider'],
    expand: true,
  };
  const childTransaction = Object.keys(cart).map(async item => {
    // Check if the deal has already been created as a parent transaction
    // If yes thn we won't create a new transaction for it
    const isDealIsParent = item === listing?.id?.uuid;

    const quantity = cart[item]?.count;
    const isService = cart[item]?.type === SERVICE_LISTING_TYPE;
    const isDeal = cart[item]?.type === DEAL_LISTING_TYPE;
    const dealListingIds = cart[item]?.dealListingIds;

    const processAlias = isService ? 'default-booking/release-1' : 'default-purchase/release-1';
    const transitionName = transitions.CHILD_REQUEST_PAYMENT;

    const handleSuccess = response => {
      return response.data.data.id.uuid; // Ensure this returns the expected ID
    };
    const handleError = error => {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('[CheckoutPage] Child initiate error', error?.message || error);
      }
      throw error;
    };

    if (isDeal) {
      const isServiceDealItem = dealListingIds?.[0]?.type === SERVICE_LISTING_TYPE;
      // Lets initiate-privileged.js resolve the linked service's discount
      // and price this parent transaction (a day-unit placeholder that
      // otherwise just trusts the deal's own already-discounted price, with
      // no visible breakdown) as an hourly service instead — see
      // dealPricing.js / lineItems.js.
      const dealServiceLinkageMaybe = isServiceDealItem
        ? {
            dealServiceId: dealListingIds[0]?.id,
            dealServiceBookingStart: dealListingIds[0]?.bookingStart,
            dealServiceBookingEnd: dealListingIds[0]?.bookingEnd,
          }
        : {};

      // Only create a new deal if its not already been created
      let dealParentTransactionId = parentTransactionId;
      if (!isDealIsParent) {
        const initialDealParams = {
          processAlias: isServiceDealItem
            ? 'default-deal-booking/release-1'
            : 'default-deal-purchase/release-1',
          transition: 'transition/request-payment',
          params: {
            listingId: item,
            bookingStart: moment()
              .startOf('day')
              .toISOString(),
            bookingEnd: moment()
              .add(1, 'day')
              .startOf('day')
              .toISOString(),
            protectedData: {
              unitType: 'day',
              deliveryMethod: 'shipping',
              parentTransactionId: parentTransactionId,
              ...dealServiceLinkageMaybe,
            },
          },
        };

        // Await the initial deal creation
        const initialDealResponse = await initiatePrivileged({
          isSpeculative: false,
          bodyParams: initialDealParams,
          queryParams,
        })
          .then(handleSuccess)
          .catch(handleError);

        // Extract the new parent transaction ID from the response
        dealParentTransactionId = initialDealResponse;
      }

      // Collect all promises for the current item
      const dealPromises = cart[item]?.dealListingIds?.map(async deal => {
        const isServiceDeal = deal?.type === SERVICE_LISTING_TYPE;

        let dealParams = {};
        if (isServiceDeal) {
          dealParams = {
            processAlias: 'default-deal-booking/release-1',
            transition: 'transition/child-service-request-payment',
            params: {
              listingId: deal?.staffId,
              bookingStart: new Date(Number(deal?.bookingStart)),
              bookingEnd: new Date(Number(deal?.bookingEnd)),
              protectedData: {
                serviceId: deal?.id,
                // Lets initiate-privileged.js resolve the deal's discount
                // and price this child transaction (which drives provider
                // payout for this line) at the discounted total instead of
                // the service's raw price — see dealPricing.js.
                dealId: item,
                unitType: 'hour',
                deliveryMethod: 'pickup',
                parentTransactionId: dealParentTransactionId,
              },
            },
          };
        } else {
          dealParams = {
            processAlias: 'default-deal-purchase/release-1',
            transition: 'transition/child-product-request-payment',
            params: {
              listingId: deal?.id,
              stockReservationQuantity: quantity,
              protectedData: {
                parentTransactionId: dealParentTransactionId,
              },
            },
          };
        }

        return initiatePrivileged({
          isSpeculative: false,
          bodyParams: dealParams,
          queryParams,
        })
          .then(handleSuccess)
          .catch(handleError);
      });

      // Wait for all child item creation promises to resolve
      return Promise.all(dealPromises)
        .then(results => results.flat())
        .then(dealItemsTransactionIds => {
          return Promise.all(dealItemsTransactionIds).then(childIds => {
            const formattedChildId = childIds.flat();
            // Update child transaction ids
            const parentBodyParams = {
              id: dealParentTransactionId,
              transition: 'transition/update-child-transactions',
              params: {
                protectedData: {
                  dealChildTransactions: formattedChildId,
                },
              },
            };
            return sdk.transactions
              .transition(parentBodyParams, {
                expand: true,
              })
              .then(res => {
                // const entities = denormalisedResponseEntities(res);
                // const order = entities[0];
                // return order;
                return dealParentTransactionId;
              });
          });
        });
    } else {
      const bookingParams = {
        listingId: cart[item]?.staffId,
        bookingStart: new Date(Number(cart[item]?.bookingStart)),
        bookingEnd: new Date(Number(cart[item]?.bookingEnd)),
        protectedData: {
          serviceId: item,
          unitType: 'hour',
          deliveryMethod: 'pickup',
          parentTransactionId: parentTransactionId,
        },
      };
      const purchaseParams = {
        listingId: item,
        stockReservationQuantity: quantity,
        protectedData: {
          parentTransactionId: parentTransactionId,
        },
      };
      const bodyParams = {
        processAlias: processAlias,
        transition: transitionName,
        params: {
          ...(isService ? bookingParams : purchaseParams),
        },
      };

      return initiatePrivileged({
        isSpeculative: false,
        bodyParams,
        queryParams,
      })
        .then(handleSuccess)
        .catch(handleError);
    }
  });

  return Promise.all(childTransaction).then(childIds => {
    const formattedChildId = childIds.flat();
    // Update child transaction ids
    const parentBodyParams = {
      id: parentTransactionId,
      transition: isDealProcess
        ? 'transition/child-confirm-payment'
        : isBookingProcess
        ? bookingTransition.CONFIRM_PAYMENT
        : purchaseTransition.UPDATE_CHILD_TRANSCTIONS,
      params: {
        protectedData: {
          childTransactions: formattedChildId,
        },
      },
    };
    return sdk.transactions
      .transition(parentBodyParams, {
        expand: true,
      })
      .then(res => {
        const entities = denormalisedResponseEntities(res);
        const order = entities[0];
        return order;
      });
  });
};

/**
 * intiate child and update parent.
 * in this step we can have both products and service
 * initate child service/products. if parent is product then update the product instead of creating
 */
export const initateChildUpdateParentTransaction = params => async (dispatch, getState, sdk) => {
  try {
    const { orderParams, isBookingProcess, isDealProcess } = params;
    const response = await createChildTransactions(
      orderParams,
      sdk,
      isBookingProcess,
      isDealProcess
    );
    return response;
  } catch (error) {}
};

// //// Create Individual  transactions
export const InitiateIndividualTransactions = params => async (dispatch, getState, sdk) => {
  const { orderParams, tapTokenId, tapPaymentMethod } = params;
  const { couponCode, couponResult } = getState().CheckoutPage;
  // One reference for every cart item's transaction in this checkout, so the
  // server records them as a single use of the code.
  const couponMaybe = {
    ...(couponCode && couponResult?.status === 'applied'
      ? { couponCode, couponCheckoutRef: newCheckoutRef() }
      : {}),
    // The card being paid with: the server reads its type from Tap and adds the
    // merchant's Tap processing fee as a payout deduction (tapFeeLineItem.js).
    ...(tapTokenId ? { tapTokenId, tapPaymentMethod } : {}),
  };
  try {
    return await createIndividualTransactions(orderParams, sdk, couponMaybe);
  } catch (e) {
    // The code stopped applying between preview and submit (e.g. its last use
    // was just taken): nothing is charged -- the payment step never runs --
    // and the customer sees why, then re-previews without the code.
    const rejection = discountCodeRejection(e);
    if (rejection) {
      dispatch(couponRejected({ code: rejection.discountCode, reason: rejection.reason }));
    }
    throw e;
  }
};

// Create one transaction for each Cart Item
const createIndividualTransactions = async (orderParams, sdk, couponMaybe = {}) => {
  const { cart, chargeId } = orderParams?.protectedData || {};
  const { merchantAddress, customerAddress } = orderParams || {};

  // Delete deliveryMethod key from cart
  cart?.deliveryMethod ? delete cart?.deliveryMethod : null;

  // Query Params
  const queryParams = {
    include: ['booking', 'provider'],
    expand: true,
  };

  // Create Cart Items Transactions
  const cartItemsTransactions = Object.keys(cart).map(async item => {
    const quantity = cart[item]?.count;
    const isService = cart[item]?.type === SERVICE_LISTING_TYPE;
    const isDeal = cart[item]?.type === DEAL_LISTING_TYPE;
    const dealProcessAlias =
      cart[item]?.dealListingIds?.[0]?.type === SERVICE_LISTING_TYPE
        ? 'default-deal-booking/release-1'
        : 'default-deal-purchase/release-1';

    const itemDeliveryMethod = cart[item]?.deliveryMethod;

    const { PICKUP, INSTORE_VISIT, SHIPPING, HOME_SERVICE } = deliveryOptions || {};

    const merchantAddressMaybe =
      merchantAddress && [PICKUP, INSTORE_VISIT].includes(itemDeliveryMethod)
        ? { merchantAddress }
        : {};
    const customerAddressMaybe =
      customerAddress && [SHIPPING, HOME_SERVICE].includes(itemDeliveryMethod)
        ? { customerAddress }
        : {};

    const processAlias = isService
      ? 'default-booking/release-1'
      : isDeal
      ? dealProcessAlias
      : 'default-purchase/release-1';

    const transitionName = transitions.REQUEST_PAYMENT;

    // Success and Error Handlers
    const handleSuccess = response => {
      return response?.data?.data?.id?.uuid;
    };
    const handleError = error => {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('initiate transaction error', error?.data || error);
      }
      throw error;
    };

    ////// If current Cart Item is a Deal then first create the Deal transaction
    ////// and then its deal items transactions
    if (isDeal) {
      let dealParentTransactionId = null;

      const dealServiceChildItem = cart[item]?.dealListingIds?.[0];
      const dealServiceLinkageMaybe =
        dealServiceChildItem?.type === SERVICE_LISTING_TYPE
          ? {
              dealServiceId: dealServiceChildItem?.id,
              dealServiceBookingStart: dealServiceChildItem?.bookingStart,
              dealServiceBookingEnd: dealServiceChildItem?.bookingEnd,
            }
          : {};

      const initialDealParams = {
        processAlias: processAlias,
        transition: transitionName,
        params: {
          ...orderParams,
          listingId: item,
          bookingStart: moment()
            .startOf('day')
            .toISOString(),
          bookingEnd: moment()
            .add(1, 'day')
            .startOf('day')
            .toISOString(),
          protectedData: {
            unitType: 'day',
            deliveryMethod: itemDeliveryMethod,
            ...merchantAddressMaybe,
            ...customerAddressMaybe,
            ...dealServiceLinkageMaybe,
            // chargeId: chargeId,
          },
        },
      };

      // Await the initial deal creation
      const initialDealResponse = await initiatePrivileged({
        isSpeculative: false,
        orderData: { cart, ...couponMaybe },
        bodyParams: initialDealParams,
        queryParams,
      })
        .then(handleSuccess)
        .catch(handleError);

      // Extract the Deal transaction ID from the response
      dealParentTransactionId = initialDealResponse;

      // Now its time to create child transactions for Deal Items
      const dealPromises = cart[item]?.dealListingIds?.map(async dealItem => {
        const isServiceDeal = dealItem?.type === SERVICE_LISTING_TYPE;

        let dealItemParams = {};
        if (isServiceDeal) {
          dealItemParams = {
            processAlias: processAlias,
            transition: dealTransitions?.CHILD_SERVICE_REQUEST_PAYMENT,
            params: {
              ...orderParams,
              listingId: dealItem?.staffId,
              bookingStart: new Date(Number(dealItem?.bookingStart)),
              bookingEnd: new Date(Number(dealItem?.bookingEnd)),
              protectedData: {
                serviceId: dealItem?.id,
                unitType: 'hour',
                parentTransactionId: dealParentTransactionId,
                deliveryMethod: itemDeliveryMethod,
                ...merchantAddressMaybe,
                ...customerAddressMaybe,
              },
            },
          };
        } else {
          dealItemParams = {
            processAlias: processAlias,
            transition: dealTransitions?.CHILD_PRODUCT_REQUEST_PAYMENT,
            params: {
              ...orderParams,
              listingId: dealItem?.id,
              stockReservationQuantity: quantity,
              protectedData: {
                parentTransactionId: dealParentTransactionId,
                deliveryMethod: itemDeliveryMethod,
                ...merchantAddressMaybe,
                ...customerAddressMaybe,
              },
            },
          };
        }

        return initiatePrivileged({
          isSpeculative: false,
          orderData: { cart, ...couponMaybe },
          bodyParams: dealItemParams,
          queryParams,
        })
          .then(handleSuccess)
          .catch(handleError);
      });

      // Wait for all deal child tx creation promises to resolve
      return Promise.all(dealPromises)
        .then(results => results.flat())
        .then(dealItemsTransactionIds => {
          const parentBodyParams = {
            id: dealParentTransactionId,
            transition: dealTransitions?.UPDATE_CHILD_TRANSACTIONS,
            params: {
              protectedData: {
                dealChildTransactions: dealItemsTransactionIds,
              },
            },
          };
          return sdk.transactions
            .transition(parentBodyParams, { expand: true })
            .then(() => dealParentTransactionId);
        });
    } else {
      const bookingParams = {
        ...orderParams,
        listingId: cart[item]?.staffId,
        bookingStart: new Date(Number(cart[item]?.bookingStart)),
        bookingEnd: new Date(Number(cart[item]?.bookingEnd)),
        protectedData: {
          serviceId: item,
          unitType: 'hour',
          deliveryMethod: itemDeliveryMethod,
          ...merchantAddressMaybe,
          ...customerAddressMaybe,
          // chargeId: chargeId,
        },
      };
      const purchaseParams = {
        ...orderParams,
        listingId: item,
        stockReservationQuantity: quantity,
        protectedData: {
          deliveryMethod: itemDeliveryMethod,
          ...merchantAddressMaybe,
          ...customerAddressMaybe,
          // chargeId: chargeId,
        },
      };
      const bodyParams = {
        processAlias: processAlias,
        transition: transitionName,
        params: {
          ...(isService ? bookingParams : purchaseParams),
        },
      };

      return initiatePrivileged({
        isSpeculative: false,
        orderData: { cart, ...couponMaybe },
        bodyParams,
        queryParams,
      })
        .then(handleSuccess)
        .catch(handleError);
    }
  });

  return Promise.all(cartItemsTransactions).then(cartItemsTxs => cartItemsTxs);
};

// Create one transaction for each Cart Item
// const createIndividualTransactions = async (orderParams, sdk) => {
//   const cart = orderParams?.protectedData?.cart || {};
//   cart?.deliveryMethod ? delete cart?.deliveryMethod : null;

//   const chargeId = orderParams?.protectedData?.chargeId;

//   const queryParams = {
//     include: ['booking', 'provider'],
//     expand: true,
//   };

//   const cartItemsTransactions = Object.keys(cart).map(async item => {
//     const quantity = cart[item]?.count;
//     const isService = cart[item]?.type === SERVICE_LISTING_TYPE;
//     const isDeal = cart[item]?.type === DEAL_LISTING_TYPE;

//     const processAlias = isService
//       ? 'default-booking/release-1'
//       : isDeal
//         ? 'default-deal-booking/release-1'
//         : 'default-purchase/release-1';

//     const transitionName = transitions.REQUEST_PAYMENT;

//     const handleSuccess = response => {
//       return response?.data?.data?.id?.uuid;
//     };
//     const handleError = error => {
//       console.log('initiate transaction error', JSON.stringify(error));
//     };

//     ////// If current Cart Item is a Deal then first create the Deal transaction
//     ////// and then its deal items transactions
//     if (isDeal) {
//       let dealParentTransactionId = null;

//       const initialDealParams = {
//         processAlias: processAlias,
//         transition: transitionName,
//         params: {
//           ...orderParams,
//           listingId: item,
//           bookingStart: moment()
//             .startOf('day')
//             .toISOString(),
//           bookingEnd: moment()
//             .add(1, 'day')
//             .startOf('day')
//             .toISOString(),
//           protectedData: {
//             unitType: 'day',
//             deliveryMethod: 'shipping',
//             chargeId: chargeId,
//           },
//         },
//       };

//       // Await the initial deal creation
//       const initialDealResponse = await initiatePrivileged({
//         isSpeculative: false,
//         orderData: { cart },
//         bodyParams: initialDealParams,
//         queryParams,
//       })
//         .then(handleSuccess)
//         .catch(handleError);

//       // Extract the parent transaction ID from the response
//       dealParentTransactionId = initialDealResponse;

//       // Now its time to create child transactions for Deal Items
//       const dealPromises = cart[item]?.dealListingIds?.map(async dealItem => {
//         const isServiceDeal = dealItem?.type === SERVICE_LISTING_TYPE;

//         let dealItemParams = {};
//         if (isServiceDeal) {
//           dealItemParams = {
//             processAlias: processAlias,
//             transition: dealTransitions?.CHILD_SERVICE_REQUEST_PAYMENT,
//             params: {
//               ...orderParams,
//               listingId: dealItem?.staffId,
//               bookingStart: new Date(Number(dealItem?.bookingStart)),
//               bookingEnd: new Date(Number(dealItem?.bookingEnd)),
//               protectedData: {
//                 serviceId: dealItem?.id,
//                 unitType: 'hour',
//                 deliveryMethod: 'pickup',
//                 parentTransactionId: dealParentTransactionId,
//               },
//             },
//           };
//         } else {
//           dealItemParams = {
//             processAlias: processAlias,
//             transition: dealTransitions?.CHILD_PRODUCT_REQUEST_PAYMENT,
//             params: {
//               ...orderParams,
//               listingId: dealItem?.id,
//               stockReservationQuantity: quantity,
//               protectedData: {
//                 parentTransactionId: dealParentTransactionId,
//               },
//             },
//           };
//         }

//         return initiatePrivileged({
//           isSpeculative: false,
//           orderData: { cart },
//           bodyParams: dealItemParams,
//           queryParams,
//         })
//           .then(handleSuccess)
//           .catch(handleError);
//       });

//       // Wait for all child item creation promises to resolve
//       return Promise.all(dealPromises)
//         .then(results => results.flat())
//         .then(dealItemsTransactionIds => {
//           return Promise.all(dealItemsTransactionIds).then(childIds => {
//             // // Store dealItems transactionsIds in its Deal
//             const parentBodyParams = {
//               id: dealParentTransactionId,
//               transition: dealTransitions?.UPDATE_CHILD_TRANSACTIONS,
//               params: {
//                 protectedData: {
//                   dealChildTransactions: dealItemsTransactionIds,
//                 },
//               },
//             };
//             return sdk.transactions
//               .transition(parentBodyParams, {
//                 expand: true,
//               })
//               .then(res => {
//                 // Transition dealItems transaction to Confirm
//                 return Promise.all(
//                   dealItemsTransactionIds.map(dealItem => {
//                     return sdk.transactions.transition({
//                       id: dealItem,
//                       transition: dealTransitions?.DEAL_CHILD_CONFIRM_PAYMENT,
//                       params: {},
//                     });
//                   })
//                 ).then(() => {
//                   return dealParentTransactionId;
//                 });
//               });
//           });
//         });
//     } else {
//       const bookingParams = {
//         ...orderParams,
//         listingId: cart[item]?.staffId,
//         bookingStart: new Date(Number(cart[item]?.bookingStart)),
//         bookingEnd: new Date(Number(cart[item]?.bookingEnd)),
//         protectedData: {
//           serviceId: item,
//           unitType: 'hour',
//           deliveryMethod: 'pickup',
//           chargeId: chargeId,
//         },
//       };
//       const purchaseParams = {
//         ...orderParams,
//         listingId: item,
//         stockReservationQuantity: quantity,
//         protectedData: {
//           chargeId: chargeId,
//         },
//       };
//       const bodyParams = {
//         processAlias: processAlias,
//         transition: transitionName,
//         params: {
//           ...(isService ? bookingParams : purchaseParams),
//         },
//       };

//       return initiatePrivileged({
//         isSpeculative: false,
//         orderData: { cart },
//         bodyParams,
//         queryParams,
//       })
//         .then(handleSuccess)
//         .catch(handleError);
//     }
//   });

//   return Promise.all(cartItemsTransactions).then(cartItemsTxs => {
//     cartItemsTxs.map(cartItemTx => {
//       const bodyParams = {
//         id: cartItemTx,
//         transition: bookingTransition?.CHILD_CONFIRM_PAYMENT,
//         params: {
//           protectedData: {
//             // childTransactions: formattedChildId,
//           },
//         },
//       };
//       return sdk.transactions
//         .transition(bodyParams, {
//           expand: true,
//         })
//         .then(res => {
//           console.log('res', res);
//           const entities = denormalisedResponseEntities(res);
//           const order = entities[0];
//           return order;
//         });
//     });

//     return cartItemsTxs;
//   });
// };

/**
 * initiate child transactions
 */
export const initateChildTransactions = ({
  orderParams,
  processAlias,
  transactionId,
  transitionName,
  // isPrivilegedTransition,
}) => (dispatch, getState, sdk) => {
  try {
    const { attributes, id, relationships } = orderParams;
    const parentTransactionId = id.uuid;
    const { cart, deliveryMethod } = attributes?.protectedData;
    const { listing } = relationships || {};

    //remove parent id
    delete cart[listing?.data?.id?.uuid];
    cart?.deliveryMethod ? delete cart?.deliveryMethod : null;

    const queryParams = {
      include: ['booking', 'provider'],
      expand: true,
    };

    const chidTransaction = Object.keys(cart).map(item => {
      const count = cart[item].count;

      const bodyParams = {
        processAlias: processAlias,
        transition: transitionName,
        params: {
          listingId: item,
          stockReservationQuantity: count,
          protectedData: {
            parentTransactionId: parentTransactionId,
          },
        },
      };

      const handleSuccess = response => {
        return response?.data?.data?.id?.uuid;
      };

      const handleError = error => {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('[CheckoutPage] Deal child initiate error', error?.message || error);
        }
        throw error;
      };

      return initiatePrivileged({
        isSpeculative: false,

        bodyParams,
        queryParams,
      })
        .then(handleSuccess)
        .catch(handleError);
    });

    return Promise.all(chidTransaction).then(childIds => {
      const parentProtectedData = {
        childTransactions: childIds,
      };

      // Update child transaction ids
      const parentBodyParams = {
        id: parentTransactionId,
        transition: transitions.UPDATE_CHILD_TRANSACTIONS,
        params: {
          protectedData: parentProtectedData,
        },
      };

      return sdk.transactions
        .transition(parentBodyParams, {
          expand: true,
        })
        .then(res => {
          const entities = denormalisedResponseEntities(res);
          const order = entities[0];
          return order;
        });
    });
  } catch (error) {}
};

/**
 * update child transactions
 */
export const updateChildTransactions = ({ paymentId, txIds = [], authData, remainderAuthData }) => async (
  dispatch,
  getState,
  sdk
) => {
  const idsToProcess = Array.isArray(txIds) ? txIds.filter(Boolean) : [];
  if (idsToProcess.length === 0) {
    console.warn('[CheckoutPage][Split] updateChildTransactions: no txIds to process, protectedData NOT written', {
      paymentId,
    });
    return [];
  }

  // 50-50 customer payment split only: also write depositAuthData /
  // remainderAuthData so cancellation/redemption logic can address each
  // Tap authorization independently. `authData`/`paymentId` are still
  // written exactly as before for every booking, split or not.
  const splitProtectedDataMaybe = remainderAuthData
    ? { depositAuthData: authData, remainderAuthData }
    : {};

  const response = await Promise.all(
    idsToProcess.map(txId => {
      const bodyParams = {
        id: new UUID(txId),
        // TODO : import transition name
        transition: 'transition/child-confirm-payment',
        params: {
          protectedData: {
            paymentId,
            authData,
            ...splitProtectedDataMaybe,
          },
        },
      };
      return sdk.transactions
        .transition(bodyParams, { expand: true })
        .then(res => {
          const entities = denormalisedResponseEntities(res);

          const entity = entities?.[0] || {};
          const { dealChildTransactions = [] } = entity?.attributes?.protectedData || {};

          if (dealChildTransactions.length) {
            const confirmDealItems = dealChildTransactions.map(dealChildTx => {
              const bodyParams = {
                id: dealChildTx,
                // TODO : import transition name
                transition: 'transition/deal-child-confirm-payment',
                params: {
                  protectedData: {
                    paymentId,
                    authData,
                    ...splitProtectedDataMaybe,
                  },
                },
              };

              sdk.transactions.transition(bodyParams, { expand: true });
            });
          }
          return entity;
        })
        .catch(e => {
          if (process.env.NODE_ENV !== 'production') {
            console.error('[CheckoutPage] Error in confirm payment', e?.message);
          }
          throw e;
        });
    })
  );

  return Array.isArray(response) ? response.map(tx => tx.id.uuid) : [];
};

/**
 * initiate child bookings
 */
export const initiateChildBookings = ({
  orderParams,
  childTransitionName,
  parentTransitionName,
  processAlias,
}) => (dispatch, getState, sdk) => {
  try {
    const { attributes, id, relationships } = orderParams;
    const parentTransactionId = id.uuid;
    const { cart, deliveryMethod } = attributes?.protectedData;

    const firstKey = Object.keys(cart)[0];
    delete cart[firstKey];

    cart?.deliveryMethod ? delete cart?.deliveryMethod : null;

    const queryParams = {
      include: ['booking', 'provider'],
      expand: true,
    };
    const chidTransaction = Object.keys(cart).map(item => {
      const bodyParams = {
        processAlias: processAlias,
        transition: childTransitionName,
        params: {
          listingId: cart[item]?.staffId,
          bookingStart: new Date(Number(cart[item]?.bookingStart)),
          bookingEnd: new Date(Number(cart[item]?.bookingEnd)),
          protectedData: {
            serviceId: item,
            unitType: 'hour',
            deliveryMethod: 'pickup',
            parentTransactionId: parentTransactionId,
          },
        },
      };
      const handleSuccess = response => {
        return response?.data?.data?.id?.uuid;
      };

      const handleError = error => {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('[CheckoutPage] Child booking initiate error', error?.message || error);
        }
        throw error;
      };

      return initiatePrivileged({
        isSpeculative: false,
        bodyParams,
        queryParams,
      })
        .then(handleSuccess)
        .catch(handleError);
    });
    return Promise.all(chidTransaction).then(childIds => {
      // Update child transaction ids
      const parentBodyParams = {
        id: parentTransactionId,
        transition: parentTransitionName,
        params: {
          protectedData: {
            childTransactions: childIds,
          },
        },
      };

      return sdk.transactions
        .transition(parentBodyParams, {
          expand: true,
        })
        .then(res => {
          const entities = denormalisedResponseEntities(res);
          const order = entities[0];
          return order;
        });
    });
  } catch (error) {}
};

/**
 * update child bookings
 */
export const updateChildBookings = ({ orderParams, transitionName, childIds }) => (
  dispatch,
  getState,
  sdk
) => {
  try {
    return Promise.all(
      childIds.map(item => {
        const childBodyParams = {
          id: item,
          transition: transitionName,
          params: {},
        };
        return sdk.transactions.transition(childBodyParams, {
          expand: true,
        });
      })
    ).then(res => {
      return orderParams;
    });
  } catch (error) {}
};

// replace this thunk later in cart slice
export const clearAuthorCart = () => (dispatch, getState, sdk) => {
  try {
    const state = getState();
    const currentAuthor = state?.CartPage?.currentAuthor;
    const cart = state?.CartPage?.cart;

    const newCart = {
      ...cart,
    };

    delete newCart[currentAuthor?.id?.uuid];

    return sdk.currentUser.updateProfile({
      privateData: {
        cart: newCart,
      },
    });
  } catch (error) {}
};

export const sendMessage = params => (dispatch, getState, sdk) => {
  const message = params.message;
  const orderId = params.id;

  if (message) {
    return sdk.messages
      .send({ transactionId: orderId, content: message })
      .then(() => {
        return { orderId, messageSuccess: true };
      })
      .catch(e => {
        log.error(e, 'initial-message-send-failed', { txId: orderId });
        return { orderId, messageSuccess: false };
      });
  } else {
    return Promise.resolve({ orderId, messageSuccess: true });
  }
};

/**
 * Initiate transaction against default-inquiry process
 * Note: At this point inquiry transition is made directly against Marketplace API.
 *       So, client app's server is not involved here unlike with transitions including payments.
 *
 * @param {*} inquiryParams contains listingId and protectedData
 * @param {*} processAlias 'default-inquiry/release-1'
 * @param {*} transitionName 'transition/inquire-without-payment'
 * @returns
 */
export const initiateInquiryWithoutPayment = (inquiryParams, processAlias, transitionName) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(initiateInquiryRequest());

  if (!processAlias) {
    const error = new Error('No transaction process attached to listing');
    log.error(error, 'listing-process-missing', {
      listingId: listing?.id?.uuid,
    });
    dispatch(initiateInquiryError(storableError(error)));
    return Promise.reject(error);
  }

  const bodyParams = {
    transition: transitionName,
    processAlias,
    params: inquiryParams,
  };
  const queryParams = {
    include: ['provider'],
    expand: true,
  };

  return sdk.transactions
    .initiate(bodyParams, queryParams)
    .then(response => {
      const transactionId = response.data.data.id;
      dispatch(initiateInquirySuccess());
      return transactionId;
    })
    .catch(e => {
      dispatch(initiateInquiryError(storableError(e)));
      throw e;
    });
};

/**
 * Initiate or transition the speculative transaction with the given
 * booking details
 *
 * The API allows us to do speculative transaction initiation and
 * transitions. This way we can create a test transaction and get the
 * actual pricing information as if the transaction had been started,
 * without affecting the actual data.
 *
 * We store this speculative transaction in the page store and use the
 * pricing info for the booking breakdown to get a proper estimate for
 * the price with the chosen information.
 */
export const speculateTransaction = (
  orderParams,
  processAlias,
  transactionId,
  transitionName,
  isPrivilegedTransition
) => (dispatch, getState, sdk) => {
  const { orderData: newOrderData = {}, couponCode } = getState().CheckoutPage;

  const { isCheckoutPage, cart, deliveryMethod } =
    newOrderData && Object.keys(newOrderData).length ? newOrderData : orderParams;

  if (!isCheckoutPage) dispatch(speculateTransactionRequest());

  // If we already have a transaction ID, we should transition, not
  // initiate.
  const isTransition = !!transactionId;

  const {
    quantity,
    bookingDates,
    cart: oldCart,
    deliveryMethod: oldDeliveryMethods,
    ...otherOrderParams
  } = orderParams;
  const quantityMaybe = quantity ? { stockReservationQuantity: quantity } : {};
  const bookingParamsMaybe = bookingDates || {};

  // Parameters only for client app's server
  const orderData = {
    cart,
    ...(deliveryMethod ? { deliveryMethod } : {}),
    ...(couponCode ? { couponCode } : {}),
  };

  // Parameters for Marketplace API
  const transitionParams = {
    ...quantityMaybe,
    ...bookingParamsMaybe,
    ...otherOrderParams,
    cardToken: 'CheckoutPage_speculative_card_token',
  };

  const bodyParams = isTransition
    ? {
        id: transactionId,
        transition: transitionName,
        params: transitionParams,
      }
    : {
        processAlias,
        transition: transitionName,
        params: transitionParams,
      };

  const queryParams = {
    include: ['booking', 'provider', 'listing'],
    expand: true,
  };

  const handleSuccess = response => {
    const entities = denormalisedResponseEntities(response);
    if (entities.length !== 1) {
      throw new Error('Expected a resource in the speculate response');
    }
    const tx = entities[0];
    dispatch(speculateTransactionSuccess(tx, response?.data?.coupon || null));
  };

  const handleError = e => {
    log.error(e, 'speculate-transaction-failed', {
      listingId: transitionParams?.listingId?.uuid,
      ...quantityMaybe,
      ...bookingParamsMaybe,
      ...orderData,
    });
    return dispatch(speculateTransactionError(storableError(e)));
  };

  if (isTransition && isPrivilegedTransition) {
    // transition privileged
    return transitionPrivileged({ isSpeculative: true, orderData, bodyParams, queryParams })
      .then(handleSuccess)
      .catch(handleError);
  } else if (isTransition) {
    // transition non-privileged
    return sdk.transactions
      .transitionSpeculative(bodyParams, queryParams)
      .then(handleSuccess)
      .catch(handleError);
  } else if (isPrivilegedTransition) {
    // initiate privileged
    return initiatePrivileged({ isSpeculative: true, orderData, bodyParams, queryParams })
      .then(handleSuccess)
      .catch(handleError);
  } else {
    // initiate non-privileged
    return sdk.transactions
      .initiateSpeculative(bodyParams, queryParams)
      .then(handleSuccess)
      .catch(handleError);
  }
};

/**
 * Creates individual stock reservation transactions for all the listings in
 * the associated transaction's protectedData.cart, and updates the main
 * transaction protected data with the child transaction ids.
 * @param {*} tx Main cart transaction – expects protectedData.cart
 * @param {*} processAlias Cart stock process alias
 * @param {*} cartItemTransitionName Transition to initiate stock transaction
 * @param {*} parentTransitionName Transition to update the main transaction with child transaction ids
 * @returns 'order', i.e. the updated transaction
 */
export const createStockReservationTransactions = (
  tx,
  processAlias,
  cartItemTransitionName,
  parentTransitionName
) => (dispatch, getState, sdk) => {
  const listingsCart = { ...tx.attributes.protectedData.cart };
  delete listingsCart.deliveryMethod;
  // Create transactions with the cart item process to update stock reservations
  if (listingsCart.length == 0) {
    return tx;
  } else {
    const additionalTransactionFns = Object.keys(listingsCart).map(item => {
      const count = listingsCart[item].count;
      // initiate
      const bodyParams = {
        processAlias: processAlias,
        transition: cartItemTransitionName,
        params: {
          listingId: item,
          stockReservationQuantity: count,
          protectedData: {
            parentTransactionId: tx.id.uuid,
          },
        },
      };

      return sdk.transactions.initiate(bodyParams, { expand: true }).then(res => {
        return {
          listingId: item,
          stockTransactionId: res.data.data.id.uuid,
        };
      });
    });

    return Promise.all(additionalTransactionFns)
      .then(txs => {
        const childTransactions = txs.reduce((children, child) => {
          return {
            ...children,
            [child.listingId]: child.stockTransactionId,
          };
        }, {});

        const parentProtectedData = {
          ...tx.attributes.protectedData,
          childTransactions,
        };

        // Update child transaction ids
        const parentBodyParams = {
          id: tx.id,
          transition: parentTransitionName,
          params: {
            protectedData: parentProtectedData,
          },
        };

        return sdk.transactions.transition(parentBodyParams, { expand: true });
      })
      .then(resp => {
        return resp.data.data;
      });
  }
};

/**
 * Updates the specified transaction's child transactions using the specified transition
 * @param {*} tx Main transaction – expects protectedData.childTransactions
 * @param {*} transitionName Transition to apply to protectedData.childTransactions array
 * @returns 'tx', i.e. the main transaction
 */
export const updateStockReservationTransactions = (tx, transitionName) => (
  dispatch,
  getState,
  sdk
) => {
  const childTransactions = Object.values(tx.attributes.protectedData.childTransactions);

  const updateFns = childTransactions.map(childTx => {
    const bodyParams = {
      id: childTx,
      transition: transitionName,
      params: {},
    };

    return sdk.transactions.transition(bodyParams).then(resp => {
      return resp.data;
    });
  });

  Promise.all(updateFns);

  return tx;
};

// StripeCustomer is a relantionship to currentUser
// We need to fetch currentUser with correct params to include relationship
export const stripeCustomer = () => (dispatch, getState, sdk) => {
  dispatch(stripeCustomerRequest());

  return dispatch(fetchCurrentUser({ include: ['stripeCustomer.defaultPaymentMethod'] }))
    .then(response => {
      dispatch(stripeCustomerSuccess());
    })
    .catch(e => {
      dispatch(stripeCustomerError(storableError(e)));
    });
};

export const fetchBusinessListing = listing => (dispatch, getState, sdk) => {
  const authorId = listing?.author?.id?.uuid;

  if (authorId) {
    fetchBusinessListingRequest();
    return sdk.listings
      .query(
        {
          authorId: authorId,
          pub_listingType: BUSINESS_PROFILE_LISTING_TYPE,
        },
        { expand: true }
      )
      .then(businessListing => {
        dispatch(addMarketplaceEntities(businessListing));
        dispatch(fetchBusinessListingSuccess(businessListing));
      })
      .catch(e => {
        dispatch(fetchBusinessListingError(storableError(e)));
      });
  }
};
